/**
 * PublicOnboardingPage.jsx
 * =========================
 *
 * Page publique : présentation interactive d'onboarding client.
 * URL : /docs/client/onboarding
 *
 * Affiche le slideshow plein écran. À la fermeture, retourne vers /docs/client.
 * Aucune auth requise (la formation est librement consultable).
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import OnboardingSlideshow from '../components/docs/OnboardingSlideshow';
import { ONBOARDING_SLIDES } from '../components/docs/OnboardingSlidesData';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PublicOnboardingPage = () => {
  const navigate = useNavigate();
  return (
    <div data-testid="public-onboarding-page">
      <OnboardingSlideshow
        slides={ONBOARDING_SLIDES}
        onClose={() => navigate('/docs/client')}
        pdfDownloadUrl={`${BACKEND_URL}/api/uploads/docs/Formation_Client_Baobab_Connect.pdf`}
      />
    </div>
  );
};

export default PublicOnboardingPage;
